import React, { useContext } from 'react';
import { useHistory } from 'react-router-dom';
import { useMediaQuery } from 'react-responsive'
import isEmpty from 'lodash/isEmpty';

import Markup from '../../../markup';
import { Tabs, MouseTabs, MobileTabsMouse, MobileTabs } from '../../../const/tabs';
import { device } from '../../../const/device';
import BuilderContext from '../../../builder/hooks/context';
import useExporter from "../../../builder/hooks/useExporter";
import pickBy from "lodash/pickBy";

function Header({ items, setSelectedItem, selectedItem, page }) {
  const history = useHistory();
  const { builder } = useContext(BuilderContext);
  const exporter = useExporter(builder);

  const isTablet = useMediaQuery({ query: `(${device.tablet})` })
  const isMobile = useMediaQuery({ query: `(${device.mobileL})` })

  const tabsList = isMobile ? (builder.modelData?.surffaceList?.length? MobileTabsMouse : MobileTabs) : (builder.modelData?.surffaceList?.length? MouseTabs : Tabs);

  const filterTabs = (tab) => {
    return pickBy(tab, (value, key) => {
      switch(key){
        case "collar": return builder?.modelData?.collarList.length;
        case "naming": return builder?.options?.text;
        case "sponsor": return builder?.logoTabs?.sponsorLogo;
        case "specs": return !(isMobile && !builder?.options?.sex && !builder?.options?.sleeve);
        //mouse mat tabs
        case "surface":return builder.modelData?.surffaceList?.length;
        case "image":return builder.modelData?.surffaceList?.length;
        case "additional_images":return builder.modelData?.surffaceList?.length;
        default: return true;
      }
    });
  }

  const filterPages = (pages) => {
    return pickBy(pages, (value, key) => {
      switch(key){
        case "logos": return builder?.logoTabs?.teamLogo || builder?.logoTabs?.sponsorLogo || builder?.logoTabs?.image;
        default: return true;
      }
    });
  }

  const _tabs = filterTabs(tabsList[page]);
  
  const pages = Object.keys(filterPages(tabsList)); 
  const tabs = Object.keys(_tabs);
  
  const isLastScreen = tabs?.indexOf(selectedItem) === tabs.length - 1;
  const isFirstScreen = tabs?.indexOf(selectedItem) === 0;
  const isLastPage = pages?.indexOf(page) === pages.length - 1;
  const isFirstPage = pages?.indexOf(page) === 0;

  const forward = () => {
    if (isLastPage && isLastScreen) return;

    if (isLastScreen) {
      history.push(`/${pages[pages?.indexOf(page) + 1]}`);
    } else {
      setSelectedItem(tabs[tabs?.indexOf(selectedItem) + 1])
    }
  };
  const back = () => {
    if (isFirstPage && isFirstScreen){
      history.push('/');
      window.history.replaceState({}, null, window.location.origin + window.location.pathname);
      return;
    }

    if (isFirstScreen) {
      let prevPage = pages[pages?.indexOf(page) - 1];
      let prevPageLastTab = Object.keys(filterTabs(tabsList[prevPage])).length - 1;
      history.push(`/${prevPage}/${prevPageLastTab}`);
    } else {
      setSelectedItem(tabs[tabs?.indexOf(selectedItem) - 1])
    }
  };

  return (
    <>
      <Markup.Global.Tab.Container>
        <Markup.Global.Tab.TitleContainer>
          {!isEmpty(items) ? Object.keys(items)
            .map(item => (
              <Markup.Global.Tab.Item
                key={item}
                onClick={() => setSelectedItem(item)}
                active={item === selectedItem}
                themeColor={builder.membersData.colorTheme}
              >
                {item === 'sponsor' ? 'Images' : items[item]}
              </Markup.Global.Tab.Item>
            )) : ''
          }
        </Markup.Global.Tab.TitleContainer>

        <Markup.Global.Tab.IconContainer>
          <Markup.Global.Button.ButtonIconLeftArrow onClick={back} />
          {isLastScreen && !isLastPage ?
            <Markup.Global.Button.ButtonIconSubmit onClick={forward} />
            : (isTablet && isLastPage && isLastScreen ? null : <Markup.Global.Button.ButtonIconRightArrow onClick={forward} disabled={isLastPage && isLastScreen} />)
          }

          {isTablet && isLastScreen && isLastPage ? <Markup.Global.Button.ButtonIconRightArrow disabled={true} />: ''}
        </Markup.Global.Tab.IconContainer>
      </Markup.Global.Tab.Container>
    </>
  );
}

export default React.memo(Header);
